// extracted by mini-css-extract-plugin
export default {"title":"Payment_title__ibb54","title__survey--used":"Payment_title__survey--used__D7Epk"};